import { UNKNOWN, sortCleanTranslate, populatePlayerPositionMap } from './utils';
import { SportName } from '@shared/enums/SportName';

export class HornussenPlayerPositionHandler {
	#playerPositionsMap = {
		[UNKNOWN]: [],
	};

	constructor(players) {
		populatePlayerPositionMap(this.#playerPositionsMap, players);
	}

	getLineup() {
		return sortCleanTranslate(this.#playerPositionsMap, SportName.HORNUSSEN);
	}
}
